// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.FieldItem.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Field Container for Drop Field
 */

import classnames from 'classnames';
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import constants from 'logic/data/Izenda.ReportBodyConstants';
import ReportDesignerWidget from 'share/components/hoc/Izenda.ReportDesignerWidget';
import { pick, isEqual, flow } from 'lodash/fp';

class FieldItem extends Component {
  componentDidMount() {
    this.props.itemData.offset = this.getOffset();
  }

  componentDidUpdate() {
    this.props.itemData.offset = this.getOffset();
    // Reset style field item when hover out container
    if (!this.props.isOverContainer) {
      this.refs.fieldItem.removeAttribute('style');
    }
  }

  render() {
    const props = this.props;
    const store = props.store;
    const reportFilters = store.reportFilters;
    const container = props.container || {};
    const canAccess = props.canAccess && props.canAccess(props.item, container);
    const item = props.itemData || {};
    const reportPart = props.reportPart;

    const deleteElement = () => {
      reportPart.removeFieldFromContainer(container, item);
      props.onDeleteElement && props.onDeleteElement(item);
      reportFilters.removeAggregatedField(item);
      reportPart.shouldUpdatePreview && props.store.needUpdatePreview(reportPart);
    };

    const className = classnames('field-element', {
      'can-drop': doesCanDropFieldContainerItem(),
      'field-element-selected': props.isRegistedItem && isConfigField(item)
    });

    const fieldName = item.field && item.field.visible ? item.name : constants.FIELD_HIDDEN_LABEL;

    return (
      <div className="field-wrapper" ref="fieldItem">
        <div className={className} key={item.name}>
          <span
            className="field-label overflow-text"
            onMouseDown={props.onClick}
            onTouchStart={props.onClick}
            title={fieldName}
          >
            {fieldName}
          </span>
          <span className="icon-cancel field-icon" onClick={deleteElement} />
        </div>
      </div>
    );

    function doesCanDropFieldContainerItem() {
      return canAccess && props.isOver && props.item.dragItem !== props.itemData;
    }

    function isConfigField(field) {
      return isEqual(field, reportPart.configField);
    }
  }

  getOffset() {
    return pick(
      ['x', 'y', 'width', 'height', 'left', 'right', 'top', 'bottom'],
      this.refs.fieldItem.getBoundingClientRect()
    );
  }
}

const enhance = flow(
  observer,
  ReportDesignerWidget.wrapper
);

export default enhance(FieldItem);



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/FieldContainers/Izenda.FieldItem.js